(function($) {

	class PushLogicAjaxHandler {
		constructor() {
		  this.secureToken = null;
		  this.tokenExpiry = 0;
		  this.tokenEndpoint = this.getEndpointUrl() + '/webhook/secure-token';
		  this.fetchSecureToken();
		  this.initAjaxSetup();
		  // Refresh the token every 4 minutes (adjust as needed)
		  setInterval(() => { this.fetchSecureToken(); }, 4 * 60 * 1000);
		}
  
		getEndpointUrl() {
		  const host = window.location.host;
		  const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
		  const live_endpoint = 'https://shopify.treasuretrails.co.uk';
  
		  if (host === 'treasure-trails-dev.myshopify.com') {
			return dev_endpoint;
		  } else if (host === 'treasuretrails.co.uk') {
			return live_endpoint;
		  } else {
			return live_endpoint;
		  }
		}
  
		fetchSecureToken() {
		  return fetch(this.tokenEndpoint)
			.then(response => {
			  if (!response.ok) throw new Error('Failed to fetch secure token');
			  return response.json();
			})
			.then(data => {
			  // Assume the returned JSON has { signature: "...", timestamp: 1234567890 }
			  this.secureToken = data;
			  // Assume token is valid for 5 minutes:
			  this.tokenExpiry = Date.now() + (5 * 60 * 1000);
			  return data;
			})
			.catch(err => {
			  console.error("Error fetching secure token:", err);
			});
		}
  
		initAjaxSetup() {
		  const self = this;
		  $.ajaxSetup({
			beforeSend: function (jqXHR, settings) {
			  // Add secure token only for URLs containing "/webhook/" or "/checkout/"
			  if (settings.url.indexOf('/webhook/') !== -1 || settings.url.indexOf('/checkout/') !== -1) {
				if (self.secureToken && Date.now() < self.tokenExpiry) {
				  jqXHR.setRequestHeader('X-Signature', self.secureToken.signature);
				  // If sending JSON data, update (or add) the timestamp property with the secure token's timestamp.
				  if (settings.data && settings.contentType && settings.contentType.indexOf('application/json') !== -1) {
					try {
					  let payload = JSON.parse(settings.data);
					  payload.timestamp = self.secureToken.timestamp;
					  settings.data = JSON.stringify(payload);
					} catch (e) {
					  console.error("Error updating payload timestamp:", e);
					}
				  }
				}
			  }
			}
		  });
		}
	}
  
	if (!window.__PushLogicAjaxHandlerInitialized) {
		window.__PushLogicAjaxHandlerInstance = new PushLogicAjaxHandler();
		window.__PushLogicAjaxHandlerInitialized = true;
	}
	
	class PushLogic_Trail_Availability  {
		
		constructor()
		{
            this.toggler();
			this.get_frontend_storage();
			this.form();
		}

        getEndpointUrl()
        {
            const host = window.location.host;
            const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
            const live_endpoint = 'https://shopify.treasuretrails.co.uk';
            
            if(host == 'treasure-trails-dev.myshopify.com')
            {
                return dev_endpoint;
            } else if(host == 'treasuretrails.co.uk') {
                return live_endpoint;
            } else {
                return live_endpoint;
            }
        }
		
		toggler()
		{
			var self = this,
				form = $('#sold-out #contact_form');
			
			if(form.length > 0)
			{
				var toggler = form.find('#notify-me');
				
				toggler.on('click', function()
				{
					var reveal = form.find('#notify-me-wrapper'),
						notify_text = form.find('#notify-me-paragraph');
						
					reveal.slideDown();
					notify_text.hide();
				});
			}
		}
		
		form()
		{
			var self = this,
				form = $('#sold-out #contact_form'),
                product_options = $('#pltt-trail-select'),
                product_qty = $('.product-form__item--quantity');
				
			if(form.length > 0)
			{
				$(form).on('submit', function(e)
				{
					e.preventDefault();
					
					var email = form.find('input[name="email"]').val(),
						product_title = form.find('input[name="product_title"]').val(),
						product_id = form.find('input[name="product_id"]').val(),
						data = {
							'email' : email,
							'product_title' : product_title,
							'product_id' : product_id,
							'access_key' : '71D3588873FCE6E89854889347291'
						};
					self.set_frontend_storage(product_id);
					self.push_data(data);
				});
                product_options.hide();
              	product_qty.hide();
			}
		}
		
		set_frontend_storage(product_id)
		{
			if(localStorage.hasOwnProperty('tttu_request_ids'))
			{
				var tttu_request_ids = localStorage.getItem('tttu_request_ids'),
					tttu_request_ids = JSON.parse(tttu_request_ids);
					
				if($.inArray(product_id, tttu_request_ids) == -1)
				{
					tttu_request_ids.push(product_id);
					localStorage.setItem('tttu_request_ids', JSON.stringify(tttu_request_ids));
				}
			} else {
				var tttu_request_ids = [];
				tttu_request_ids.push(product_id);
				localStorage.setItem('tttu_request_ids', JSON.stringify(tttu_request_ids));
			}
		}
		
		get_frontend_storage()
		{
			var form = $('#sold-out #contact_form'),
				product_id = form.find('input[name="product_id"]').val();
				
			if(form.length > 0)
			{
				if(localStorage.hasOwnProperty('tttu_request_ids'))
				{
					var tttu_request_ids = localStorage.getItem('tttu_request_ids'),
						tttu_request_ids = JSON.parse(tttu_request_ids);
                  
					if($.inArray(product_id, tttu_request_ids) !== -1)
					{
						$('#notify-me-paragraph').remove();
						$('<p class="accent-text"><strong>Thanks for registering! We will notify you when this Trail is back online.</strong></p>').prependTo(form);
                    }
				}
			}
		}
		
		set_success()
		{
			var form = $('#sold-out #contact_form');
			$('#notify-me-paragraph, #notify-me-wrapper').remove();
			$('<p class="accent-text"><strong>Thanks for registering! We will notify you when this Trail is back online.</strong></p>').prependTo(form);
		}
		
		set_failure(text)
		{
			var form = $('#sold-out #contact_form');
			$('#notify-me-paragraph, #notify-me-wrapper').remove();
			$('<p class="accent-text"><strong>' + text + '</strong></p>').prependTo(form);
		}
		
		push_data(data)
		{
			var self             = this,
				webhook_endpoint = self.getEndpointUrl() + '/webhook/trail-availability';
				
			$.ajax({

				type: 'POST',
				url: webhook_endpoint,
				crossDomain: true,
				data: JSON.stringify(data),
				dataType: 'json',
				contentType: 'application/json',

				success : function(data)
				{
					self.set_success();
				},

				error: function (jqXHR, exception)
				{
					var error = '';

					if (jqXHR.status === 0) {
						error = 'Can\'t connect.\n Verify Network.';
					} else if (jqXHR.status == 404) {
						error = 'Requested page not found (404).';
					} else if (jqXHR.status == 500) {
						error = 'Internal Server Error (500).';
					} else if (jqXHR.status == 401) {
						error = 'Request Unauthorized (401).';
					} else if (exception === 'parsererror') {
						error = 'Requested JSON parse failed.';
					} else if (exception === 'timeout') {
						error = 'Time out error.';
					} else if (exception === 'abort') {
						error = 'Ajax request aborted.';
					} else {
						error = 'Uncaught Error.\n' + jqXHR.responseText;
					}

					self.set_failure(error);
				},
			});
		}
		
	}

	jQuery(document).ready(function($) {
        (function waitForSignature() {
          const handler = window.__PushLogicAjaxHandlerInstance;
      
          if (handler?.secureToken?.signature) {
            new PushLogic_Trail_Availability;
          } else {
            setTimeout(waitForSignature, 100);
          }
        })();
    });

})(jQuery);